import type { FragmentType } from "../../../../../../../__generated__/gql";
import { graphql, useFragment } from "../../../../../../../__generated__/gql";
import { DxTextGroup } from "../../../../_components/dx-text-group";

export const SiteAboutOverviewFragment = graphql(`
  fragment SiteAboutOverview_Site on Site {
    content {
      description
    }
  }
`);

export function SiteAboutOverview({
  site: siteData,
}: {
  site: FragmentType<typeof SiteAboutOverviewFragment>;
}) {
  const site = useFragment(SiteAboutOverviewFragment, siteData);
  const { description } = site.content;

  if (description === null || description === "") return null;

  return (
    <div className="py-[16px]">
      <DxTextGroup>{description}</DxTextGroup>
    </div>
  );
}
